"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle({ className, disabled = false }: { className?: string; disabled?: boolean }) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const [localTheme, setLocalTheme] = useState<"light" | "dark">("light");

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <button className={className ?? "cursor-pointer flex h-8 w-8 items-center justify-center rounded-full text-zinc-400"}>
        <Sun className="h-4 w-4" />
      </button>
    );
  }

  const handleToggle = () => {
    if (disabled) {
      // Just toggle local state, don't change actual theme
      setLocalTheme(localTheme === "dark" ? "light" : "dark");
    } else {
      // Actually change the theme
      setTheme(resolvedTheme === "dark" ? "light" : "dark");
    }
  };

  const currentTheme = disabled ? localTheme : resolvedTheme;

  return (
    <button
      onClick={handleToggle}
      className={
        className ??
        "cursor-pointer flex h-8 w-8 items-center justify-center rounded-full text-zinc-400 transition-colors hover:text-zinc-600 dark:hover:text-zinc-300"
      }
      title={disabled ? "Theme toggle disabled on this page" : (currentTheme === "dark" ? "Switch to light mode" : "Switch to dark mode")}
    >
      {currentTheme === "dark" ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </button>
  );
}
